module.exports = __webpack_public_path__ + "img/p2-14.a8b7ea39.png";